var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongYidong1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 13.5h12.2a.8.8 0 00.8-.8V5.022a.8.8 0 00-.8-.8H8.406a1 1 0 01-.697-.282l-1.19-1.157A1 1 0 005.82 2.5H2.8a.8.8 0 00-.8.8V6",
    stroke: "#3F465C",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 9.447h7.682L6.818 7.132",
    stroke: "#3F465C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default __webpack_public_path__ + "static/tongyong_yidong1.184297f8.svg";
export { SvgTongyongYidong1 as ReactComponent };